/* ========================================
   CURSOR PARTICLES - Hover abstractions
   Gray/silver particles that burst from cursor
   when hovering interactive elements
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  const canvas = document.getElementById('global-particles');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  let cursorParticles = [];
  let isTouch = window.matchMedia('(pointer: coarse)').matches;
  if (isTouch) return; // skip on touch

  const grayPalette = [
    'rgba(190, 186, 180, 0.9)',
    'rgba(160, 156, 150, 0.85)',
    'rgba(140, 136, 130, 0.8)',
    'rgba(200, 195, 188, 0.9)',
    'rgba(180, 180, 180, 0.85)',
    'rgba(220, 215, 208, 0.9)',
    'rgba(255, 255, 255, 0.95)',
  ];

  class CursorParticle {
    constructor(x, y) {
      this.x = x;
      this.y = y;
      const angle = Math.random() * Math.PI * 2;
      const speed = Math.random() * 3 + 1;
      this.vx = Math.cos(angle) * speed;
      this.vy = Math.sin(angle) * speed;
      this.size = Math.random() * 2.5 + 0.8;
      this.color = grayPalette[Math.floor(Math.random() * grayPalette.length)];
      this.opacity = Math.random() * 0.4 + 0.6;
      this.life = 1.0;
      this.decay = Math.random() * 0.02 + 0.015;
    }

    update() {
      this.x += this.vx;
      this.y += this.vy;
      this.vx *= 0.96;
      this.vy *= 0.96;
      this.life -= this.decay;
    }

    draw() {
      if (this.life <= 0) return;
      ctx.save();
      ctx.globalAlpha = this.opacity * this.life;
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.size * this.life, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }
  }

  function spawnBurst(x, y, count = 8) {
    for (let i = 0; i < count; i++) {
      cursorParticles.push(new CursorParticle(x, y));
    }
  }

  // Burst on mouse enter interactive elements
  const selectors = '.btn, a, .product-card, .faction-card, .pillar-card, .header-icons__btn, .theme-toggle, [data-cart-toggle], [data-menu-toggle], .cart-drawer__qty button, [data-remove-item], .hero-chainzoku__product-image, .product-main__thumb';

  document.body.addEventListener('mouseenter', (e) => {
    const target = e.target.closest(selectors);
    if (!target) return;
    const rect = target.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    spawnBurst(cx, cy, 10);
  }, true);

  // Continuous trail when moving fast
  let lastX = 0, lastY = 0;
  document.addEventListener('mousemove', (e) => {
    const dx = e.clientX - lastX;
    const dy = e.clientY - lastY;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist > 35) {
      spawnBurst(e.clientX, e.clientY, 3);
      lastX = e.clientX;
      lastY = e.clientY;
    }
  }, { passive: true });

  // Click burst
  document.addEventListener('click', (e) => {
    spawnBurst(e.clientX, e.clientY, 14);
  });

  function animateCursorParticles() {
    cursorParticles = cursorParticles.filter(p => {
      p.update();
      p.draw();
      return p.life > 0;
    });
    requestAnimationFrame(animateCursorParticles);
  }
  animateCursorParticles();
});
